import React from 'react';
import { MinusIcon } from 'lucide-react';
import { excluded, phases } from '../../data/offer';
import { Section } from './Section';
export function Scope() {
  return <Section index="06" label="Planning" title="Live in 3 à 4 weken" data-id="element-89" data-mp="1iflagdtn5bhx">
      <ol className="grid gap-6 md:grid-cols-4" data-id="element-90" data-mp="14jpykrxnt0o1">
        {phases.map(phase => <li key={phase.week} className="border-t border-line pt-4" data-id="element-91" data-mp="19i16uy8b3345">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-accent" data-id="element-92" data-mp="1x6aodnyhl4ph">
              {phase.week}
            </p>
            <h3 className="mt-2 text-base font-semibold tracking-tight text-white" data-id="element-93" data-mp="225drv3ytj2vc">
              {phase.title}
            </h3>
            <p className="mt-1 text-sm leading-relaxed text-white/55" data-id="element-94" data-mp="1nf6j5fym4y7u">
              {phase.text}
            </p>
          </li>)}
      </ol>

      <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-2 border-t border-line pt-6" data-id="element-95" data-mp="2g4n8u5uum10d">
        <li className="text-xs font-semibold uppercase tracking-[0.16em] text-white/40" data-id="element-96" data-mp="2kwwqkylt7urk">
          Niet inbegrepen
        </li>
        {excluded.map(item => <li key={item} className="flex gap-2 text-sm text-white/40" data-id="element-97" data-mp="2dtsa5jqt961y">
            <MinusIcon className="mt-1 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-98" data-mp="28ymswy8csfk7" />
            <span data-id="element-99" data-mp="2mp9quo6ai1f8">{item}</span>
          </li>)}
      </ul>
    </Section>;
}